import * as Yup from 'yup';

export const contactGroupSchema = Yup.object()
  .shape({
    name: Yup.string().required('Required Field'),
    verifyIdBadge: Yup.boolean(),
    verifyRiderName: Yup.boolean(),
    verifyRiderBirthdate: Yup.boolean(),
  })
  .test(
    'atLeastOneVarificationVariant',
    'At least one verification requirement must be selected',
    (values, context) => {
      const { verifyIdBadge, verifyRiderName, verifyRiderBirthdate } = values;

      if (!(verifyIdBadge || verifyRiderName || verifyRiderBirthdate)) {
        return context.createError({
          path: 'verifyIdBadge',
          message: 'At least one verification requirement must be selected',
        });
      }

      return true;
    }
  );

export function mustBeMetProtocolValidationSchema() {
  return Yup.object().shape({
    mustBeMetProtocol: Yup.object().when('mustBeMet', {
      is: true,
      then: Yup.object().shape({
        locationProtocol: Yup.string().nullable().required('drop-off procedure is required'),
        authorizedContactGroups: Yup.array().of(contactGroupSchema).min(1, 'At least one contact group is required'),
      }),
    }),
  });
}
